import { Input } from 'antd';
import '../../style/forms/input/input.less';
import '../../style/forms/input/rtl.less';

export default Input;